import * as mobx from 'mobx';
import { EnablementStatus } from '../../../../../constants/common.constants';
import { HubConfigurationSettingsType } from '../../../../../api/event-hubs.dao';

export interface IHubConfigurationSettingEntityDTO {
    enabled: boolean;
    type: HubConfigurationSettingsType;
}

class HubConfigurationSettingEntity {
    @mobx.observable
    private isEnabled: boolean = false;
    @mobx.observable
    private typeValue: HubConfigurationSettingsType;
    @mobx.observable.deep
    private snapshot: IHubConfigurationSettingEntityDTO;

    constructor(dto: IHubConfigurationSettingEntityDTO) {
        this.fromDTO(dto);
        this.snapshot = { ...dto };
    }

    public get enabled(): boolean {
        return this.isEnabled;
    }

    public get type(): HubConfigurationSettingsType {
        return this.typeValue;
    }

    public get suffix(): EnablementStatus {
        return this.isEnabled ? EnablementStatus.ENABLED : EnablementStatus.DISABLED;
    }

    public get snapshotSuffix(): EnablementStatus {
        return this.snapshot.enabled ? EnablementStatus.ENABLED : EnablementStatus.DISABLED;
    }

    @mobx.action
    public setEnabled = (enabled: boolean): void => {
        this.isEnabled = enabled;
    };

    @mobx.action
    public toggleEnabled = (): void => {
        this.isEnabled = !this.isEnabled;
    };

    @mobx.action
    public reset = (): void => {
        this.fromDTO(this.snapshot);
    };

    @mobx.action
    public updateSnapshot = (): void => {
        this.snapshot.enabled = this.isEnabled;
        this.snapshot.type = this.typeValue;
    };

    private fromDTO = (dto: IHubConfigurationSettingEntityDTO): void => {
        this.isEnabled = dto.enabled;
        this.typeValue = dto.type;
    };
}

export { HubConfigurationSettingEntity };
